// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import React from 'react';
import { QuickTreeReactViewModel } from '../../ViewModels/QuickTreeReactViewModel';
export class QuickTreeReact extends WMComponent {
    constructor(props) {
        super(props, QuickTreeReactViewModel);
        this.resizeObserver = null;
        this.onMouseLeave = (event) => {
            this.viewModel.onMouseLeave(event);
        };
        this.onResize = this.onResize.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseWheel = this.onMouseWheel.bind(this);
        this.onDoubleClick = this.onDoubleClick.bind(this);
        props.subscribeOnResize(this.onResize);
        this.refWrappperContainer = React.createRef();
        this.refCanvas = React.createRef();
        this.resizeObserver = new ResizeObserver(() => {
            this.onResize();
        });
    }
    componentDidMount() {
        var _a;
        super.componentDidMount();
        const canvas = this.refCanvas.current;
        const ctx = canvas.getContext('2d', { alpha: false });
        this.viewModel.createQuickTree(ctx);
        this.setSizes();
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this.refWrappperContainer.current);
    }
    componentWillUnmount() {
        var _a;
        super.componentWillUnmount();
        this.props.unsubscribeOnResize(this.onResize);
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    onMouseDown(event) {
        this.viewModel.onMouseDown(event);
    }
    onMouseMove(event) {
        this.viewModel.onMouseMove(event);
    }
    onMouseUp(event) {
        this.viewModel.onMouseUp(event);
    }
    onMouseWheel(event) {
        this.viewModel.onMouseWheel(event);
    }
    onDoubleClick(event) {
        this.viewModel.onDoubleClick(event);
    }
    onResize() {
        this.viewModel.resetSizes();
        this.setSizes();
    }
    setSizes() {
        const panel = this.refWrappperContainer.current;
        const w = panel.offsetWidth;
        const h = panel.offsetHeight;
        this.viewModel.setSizes(w, h);
        const devicePixelRatio = window.devicePixelRatio || 1;
        const canvas = this.refCanvas.current;
        canvas.width = w * devicePixelRatio;
        canvas.height = h * devicePixelRatio;
        this.viewModel.setContextScale(devicePixelRatio);
        this.viewModel.quickTree.Draw();
    }
    render() {
        return (React.createElement("div", { className: "quickTreeOuter", ref: this.refWrappperContainer }, this.renderCanvas()));
    }
    renderCanvas() {
        return (React.createElement("canvas", { ref: this.refCanvas, onMouseDown: this.onMouseDown, onMouseMove: this.onMouseMove, onMouseUp: this.onMouseUp, onWheel: this.onMouseWheel, onDoubleClick: this.onDoubleClick, onMouseLeave: this.onMouseLeave }));
    }
}
